import { styled } from "@health-zelas/delta"

export const Container = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  height: '100%'
})

export const ButtonGroup = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '$xxxs',
  marginTop: '$sm',

  '@sm': {
    flexDirection: 'row',
    alignItems: 'center',
  }
})
